import type { Cell, RowData } from "@tanstack/react-table";
import type { ReactNode } from "react";
import type { AppTableFeatures } from "./app-table-features";
import { getTableColumnMeta } from "./table-column-meta";

export const ACCESS_COLUMN_ID = "access";

/** Native title tooltip for Access column when org has sub-organizations. */
export function wrapAccessTableCellContent<TData extends RowData>(
	columnId: string,
	meta: unknown,
	cell: Cell<AppTableFeatures, TData, unknown>,
	content: ReactNode,
): ReactNode {
	if (columnId !== ACCESS_COLUMN_ID) {
		return content;
	}

	const accessTooltip = getTableColumnMeta(meta)?.accessTooltip;
	if (!accessTooltip) {
		return content;
	}

	const title = accessTooltip(cell.row.original);
	if (!title) {
		return content;
	}

	return (
		<div className="min-w-0 w-fit max-w-full" title={title}>
			{content}
		</div>
	);
}
